var locale = {
  placeholder: "Select time",
  rangePlaceholder: ["Start time", "End time"]
};
export default locale;